(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5731],{

/***/ 29924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ es_radio; }
});

// UNUSED EXPORTS: Button, Group

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/rc-checkbox/es/index.js
var es = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var config_provider_context = __webpack_require__(59844);
;// CONCATENATED MODULE: ./node_modules/antd/es/radio/context.js

var RadioGroupContext = /*#__PURE__*/react.createContext(null);
var RadioGroupContextProvider = RadioGroupContext.Provider;
/* harmony default export */ var radio_context = (RadioGroupContext);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/devWarning.js
var devWarning = __webpack_require__(21687);
;// CONCATENATED MODULE: ./node_modules/antd/es/radio/radio.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









var InternalRadio = function InternalRadio(props, ref) {
  var _classNames;

  var context = react.useContext(radio_context);

  var _React$useContext = react.useContext(config_provider_context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var innerRef = react.useRef();
  var mergedRef = (0,es_ref/* composeRef */.sQ)(ref, innerRef);
  react.useEffect(function () {
    (0,devWarning/* default */.Z)(!('optionType' in props), 'Radio', '`optionType` is only support in Radio.Group.');
  }, []);

  var onChange = function onChange(e) {
    var _a, _b;

    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
    (_b = context === null || context === void 0 ? void 0 : context.onChange) === null || _b === void 0 ? void 0 : _b.call(context, e);
  };

  var customizePrefixCls = props.prefixCls,
      className = props.className,
      children = props.children,
      style = props.style,
      restProps = __rest(props, ["prefixCls", "className", "children", "style"]);

  var prefixCls = getPrefixCls('radio', customizePrefixCls);

  var radioProps = (0,esm_extends/* default */.Z)({}, restProps);

  if (context) {
    radioProps.name = context.name;
    radioProps.onChange = onChange;
    radioProps.checked = props.value === context.value;
    radioProps.disabled = props.disabled || context.disabled;
  }

  var wrapperClassString = classnames_default()("".concat(prefixCls, "-wrapper"), (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-wrapper-rtl"), direction === 'rtl'), _classNames), className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    react.createElement("label", {
      className: wrapperClassString,
      style: style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave
    }, /*#__PURE__*/react.createElement(es/* default */.Z, (0,esm_extends/* default */.Z)({}, radioProps, {
      prefixCls: prefixCls,
      ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/react.createElement("span", null, children) : null)
  );
};

var Radio = /*#__PURE__*/react.forwardRef(InternalRadio);
Radio.displayName = 'Radio';
Radio.defaultProps = {
  type: 'radio'
};
/* harmony default export */ var radio_radio = (Radio);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useMergedState.js + 1 modules
var useMergedState = __webpack_require__(3129);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(97647);
;// CONCATENATED MODULE: ./node_modules/antd/es/radio/group.js









var RadioGroup = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _React$useContext = react.useContext(config_provider_context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var size = react.useContext(SizeContext/* default */.Z);

  var _useMergedState = (0,useMergedState/* default */.Z)(props.defaultValue, {
    value: props.value
  }),
      _useMergedState2 = (0,slicedToArray/* default */.Z)(_useMergedState, 2),
      value = _useMergedState2[0],
      setValue = _useMergedState2[1];

  var onRadioChange = function onRadioChange(ev) {
    var lastValue = value;
    var val = ev.target.value;

    if (!('value' in props)) {
      setValue(val);
    }

    var onChange = props.onChange;

    if (onChange && val !== lastValue) {
      onChange(ev);
    }
  };

  var renderGroup = function renderGroup() {
    var _classNames;

    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        options = props.options,
        optionType = props.optionType,
        _props$buttonStyle = props.buttonStyle,
        buttonStyle = _props$buttonStyle === void 0 ? 'outline' : _props$buttonStyle,
        disabled = props.disabled,
        children = props.children,
        customizeSize = props.size,
        style = props.style,
        id = props.id,
        onMouseEnter = props.onMouseEnter,
        onMouseLeave = props.onMouseLeave;
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var childrenToRender = children; // 如果存在 options, 优先使用

    if (options && options.length > 0) {
      var optionsPrefixCls = optionType === 'button' ? "".concat(prefixCls, "-button") : prefixCls;
      childrenToRender = options.map(function (option) {
        if (typeof option === 'string') {
          // 此处类型自动推导为 string
          return /*#__PURE__*/react.createElement(radio_radio, {
            key: option,
            prefixCls: optionsPrefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
          }, option);
        } // 此处类型自动推导为 { label: string value: string }


        return /*#__PURE__*/react.createElement(radio_radio, {
          key: "radio-group-value-options-".concat(option.value),
          prefixCls: optionsPrefixCls,
          disabled: option.disabled || disabled,
          value: option.value,
          checked: value === option.value,
          style: option.style
        }, option.label);
      });
    }

    var mergedSize = customizeSize || size;
    var classString = classnames_default()(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(groupPrefixCls, "-").concat(mergedSize), mergedSize), (0,defineProperty/* default */.Z)(_classNames, "".concat(groupPrefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/react.createElement("div", {
      className: classString,
      style: style,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      id: id,
      ref: ref
    }, childrenToRender);
  };

  return /*#__PURE__*/react.createElement(RadioGroupContextProvider, {
    value: {
      onChange: onRadioChange,
      value: value,
      disabled: props.disabled,
      name: props.name
    }
  }, renderGroup());
});
/* harmony default export */ var group = (/*#__PURE__*/react.memo(RadioGroup));
;// CONCATENATED MODULE: ./node_modules/antd/es/radio/radioButton.js


var radioButton_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};






var RadioButton = function RadioButton(props, ref) {
  var radioGroupContext = react.useContext(radio_context);

  var _React$useContext = react.useContext(config_provider_context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls;

  var customizePrefixCls = props.prefixCls,
      radioProps = radioButton_rest(props, ["prefixCls"]);

  var prefixCls = getPrefixCls('radio-button', customizePrefixCls);

  if (radioGroupContext) {
    radioProps.checked = props.value === radioGroupContext.value;
    radioProps.disabled = props.disabled || radioGroupContext.disabled;
  }

  return /*#__PURE__*/react.createElement(radio_radio, (0,esm_extends/* default */.Z)({
    prefixCls: prefixCls
  }, radioProps, {
    type: "radio",
    ref: ref
  }));
};

/* harmony default export */ var radioButton = (/*#__PURE__*/react.forwardRef(RadioButton));
;// CONCATENATED MODULE: ./node_modules/antd/es/radio/index.js



var radio_Radio = radio_radio;
radio_Radio.Button = radioButton;
radio_Radio.Group = group;

/* harmony default export */ var es_radio = (radio_Radio);

/***/ }),

/***/ 28705:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]/edit",
      function () {
        return __webpack_require__(67658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ OriginLabel; },
  "a": function() { return /* binding */ RepostLabel; }
});

// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
;// CONCATENATED MODULE: ./src/components/label/index.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  border-radius: 6px;\n  padding: 2px 14px;\n  font-size: 14px;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Label = styled_components_browser_esm/* default.span */.ZP.span(_templateObject1(), function(param) {
    var $color = param.$color;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), $color, (0,polished_esm/* transparentize */.DZ)(0.9, $color));
});
/* harmony default export */ var label = (Label);

;// CONCATENATED MODULE: ./src/pages/blog/[slug]/components/labels.js
function labels_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function labels_templateObject() {
    var data = labels_taggedTemplateLiteral([
        ""
    ]);
    labels_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function labels_templateObject1() {
    var data = labels_taggedTemplateLiteral([
        ""
    ]);
    labels_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var OriginLabel = (0,styled_components_browser_esm/* default */.ZP)(label).attrs({
    $color: colors.T6
})(labels_templateObject());
var RepostLabel = (0,styled_components_browser_esm/* default */.ZP)(label).attrs({
    $color: colors.T5
})(labels_templateObject1());


/***/ }),

/***/ 67658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 17 modules
var tabs = __webpack_require__(87961);
// EXTERNAL MODULE: ./node_modules/@pingcap-inc/tidb-community-editor/dist/style.css
var style = __webpack_require__(72718);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/edit.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: #e9eaee;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 991px;\n  margin: 70px auto 54px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var MainWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(79531);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 44 modules
var es_select = __webpack_require__(18963);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/editing/editing.styled.js
function editing_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function editing_styled_templateObject() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  padding: 36px 37px;\n  border-radius: 6px;\n  min-height: 413px;\n  background: white;\n\n  .ant-upload {\n    display: block;\n    width: 100%;\n  }\n"
    ]);
    editing_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function editing_styled_templateObject1() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-left: -37px;\n  margin-right: -37px;\n  margin-top: -36px;\n  border-bottom: 2px ",
        " solid;\n  cursor: pointer;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n"
    ]);
    editing_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-left: -37px;\n  margin-right: -37px;\n  margin-top: -36px;\n  padding: 36px 48px;\n  border-bottom: 2px ",
        " solid;\n  font-size: 20px;\n  line-height: 30px;\n  color: #c7c7c7;\n  user-select: none;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-top: 25px;\n  display: block;\n  font-size: 32px;\n  line-height: 32px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 14px;\n  min-width: 100px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-left: 24px;\n  display: inline-block;\n  font-size: 14px;\n  min-width: 250px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  &:before {\n    content: '# ';\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-top: 30px;\n  display: flex;\n  align-items: center;\n\n  .ant-checkbox-wrapper {\n    max-width: 80px;\n    min-width: 80px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-top: 32px;\n\n  .btns {\n    > .ant-btn:not(:first-child) {\n      margin-left: 16px;\n    }\n  }\n\n  > .ant-alert {\n    margin-bottom: 32px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin: 16px 0;\n  div {\n    color: #707070;\n    a {\n      color: #73061c;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = editing_styled_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  padding: 0 11px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var Content = styled_components_browser_esm/* default.main */.ZP.main(editing_styled_templateObject());
var CoverImage = styled_components_browser_esm/* default.div */.ZP.div(editing_styled_templateObject1(), colors.B4);
var CoverImagePlaceholder = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), colors.B4);
var TitleInput = (0,styled_components_browser_esm/* default */.ZP)(input/* default.TextArea */.Z.TextArea).attrs({
    bordered: false,
    rows: 1,
    autoSize: true
})(_templateObject3());
var Meta = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var CategorySelect = (0,styled_components_browser_esm/* default */.ZP)(es_select/* default */.Z).attrs({
    bordered: false,
    showArrow: false,
    allowClear: true
})(_templateObject5());
var TagsSelect = (0,styled_components_browser_esm/* default */.ZP)(es_select/* default */.Z).attrs({
    bordered: false,
    showArrow: false,
    mode: "multiple",
    allowClear: true
})(_templateObject6());
var Tag = styled_components_browser_esm/* default.span */.ZP.span(_templateObject7());
var Footer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8());
var Actions = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9());
var Definition = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10());
var Editor = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11());

// EXTERNAL MODULE: ./node_modules/@pingcap-inc/tidb-community-editor/dist/index.full-es.js
var index_full_es = __webpack_require__(45324);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 1 modules
var notification = __webpack_require__(13448);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/alert/index.js + 2 modules
var es_alert = __webpack_require__(90567);
// EXTERNAL MODULE: ./packages/datasource/src/api/blog/index.ts + 2 modules
var blog = __webpack_require__(41826);
// EXTERNAL MODULE: ./packages/datasource/src/api/blog/common.ts
var common = __webpack_require__(70780);
// EXTERNAL MODULE: ./packages/datasource/src/api/blog/posts/index.js
var posts = __webpack_require__(88540);
// EXTERNAL MODULE: ./packages/datasource/src/api/blog/posts/[id]/index.js
var _id_ = __webpack_require__(2701);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 14 modules
var modal = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/edit.context.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var EditContext = /*#__PURE__*/ (0,react.createContext)({
    title: "",
    origin: undefined,
    category: undefined,
    tags: [],
    content: [],
    setTitle: function() {},
    setOrigin: function() {},
    setCategory: function() {},
    setTags: function() {},
    setContent: function() {}
});
EditContext.displayName = "EditContext";
function useEditContext() {
    return (0,react.useContext)(EditContext);
}
function useEditContextProvider() {
    var factory = (0,react.useMemo)(function() {
        return (0,index_full_es/* createFactory */.sw)();
    }, []);
    var ref8 = (0,react.useState)(""), title = ref8[0], setTitle = ref8[1];
    var ref1 = (0,react.useState)(undefined), coverImageURL = ref1[0], setCoverImageURL = ref1[1];
    var ref2 = (0,react.useState)(undefined), origin = ref2[0], setOrigin = ref2[1];
    var ref3 = (0,react.useState)(undefined), category = ref3[0], setCategory = ref3[1];
    var ref4 = (0,react.useState)([]), tags = ref4[0], setTags = ref4[1];
    var ref5 = (0,react.useState)([
        {
            type: "paragraph",
            children: [
                {
                    text: ""
                }
            ]
        }
    ]), content = ref5[0], setContent = ref5[1];
    var ref6 = (0,react.useState)(undefined), blogInfo = ref6[0], setBlogInfo = ref6[1];
    var ref7 = (0,react.useState)(false), loading = ref7[0], setLoading = ref7[1];
    var uploadCoverImage = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(file) {
            var ref, downloadURL, uploadURL;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return common.upload(file.name, file.type);
                    case 2:
                        ref = _ctx.sent;
                        downloadURL = ref.downloadURL;
                        uploadURL = ref.uploadURL;
                        _ctx.next = 7;
                        return axios_default().put(uploadURL, file, {
                            headers: {
                                "content-type": file.type,
                                "x-oss-object-acl": "public-read"
                            }
                        });
                    case 7:
                        setCoverImageURL(downloadURL);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var reload = (0,react.useCallback)(function(slug) {
        if (slug === "new") {
            setTitle("");
            // setOrigin(false);
            setCategory(undefined);
            setContent([
                {
                    type: "paragraph",
                    children: [
                        {
                            text: ""
                        }
                    ]
                }
            ]);
            setTags([]);
            setBlogInfo(undefined);
            setCoverImageURL(undefined);
            return Promise.resolve();
        } else {
            setLoading(true);
            return blog.getPostBySlug({
                slug: slug
            }).then(function(info) {
                setTitle(info.title);
                setOrigin(info.origin === "ORIGINAL" ? false : info.sourceURL);
                setTags(info.tags);
                setCategory(info.category);
                setContent(JSON.parse(info.content));
                setBlogInfo(info);
                setCoverImageURL(info.coverImageURL);
            }).finally(function() {
                return setLoading(false);
            });
        }
    }, []);
    return {
        factory: factory,
        reload: reload,
        loading: loading,
        blogInfo: blogInfo,
        title: title,
        setTitle: setTitle,
        coverImageURL: coverImageURL,
        setCoverImageURL: setCoverImageURL,
        uploadCoverImage: uploadCoverImage,
        origin: origin,
        setOrigin: setOrigin,
        category: category,
        setCategory: setCategory,
        tags: tags,
        setTags: setTags,
        content: content,
        setContent: setContent
    };
}
function useEditMethods() {
    var router = (0,next_router.useRouter)();
    var editContext = useEditContext();
    var ref10 = (0,react.useState)(false), operating = ref10[0], setOperating = ref10[1];
    var reload = editContext.reload;
    var slug1 = router.query.slug;
    var save = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var showMessage, callback, title, coverImageURL, origin, category, tags, content, blogInfo, ref, body, res, ref9, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    showMessage = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false, callback = _args.length > 1 && _args[1] !== void 0 ? _args[1] : function(slug) {
                        return router.push("/blog/".concat(slug, "/edit"));
                    };
                    _ctx.prev = 1;
                    title = editContext.title, coverImageURL = editContext.coverImageURL, origin = editContext.origin, category = editContext.category, tags = editContext.tags, content = editContext.content, blogInfo = editContext.blogInfo;
                    ;
                    body = {
                        title: title,
                        origin: typeof origin === "string" ? "REPOST" : "ORIGINAL",
                        sourceURL: typeof origin === "string" ? origin : null,
                        content: JSON.stringify(content),
                        category: (ref = category === null || category === void 0 ? void 0 : category.id) !== null && ref !== void 0 ? ref : null,
                        tags: tags.map(function(tag) {
                            return tag.id;
                        }),
                        coverImageURL: coverImageURL
                    };
                    if (!(slug1 === "new")) {
                        _ctx.next = 17;
                        break;
                    }
                    _ctx.next = 8;
                    return posts.create(body);
                case 8:
                    res = _ctx.sent;
                    _ctx.next = 11;
                    return reload(res.slug);
                case 11:
                    _ctx.next = 13;
                    return callback === null || callback === void 0 ? void 0 : callback(res.slug);
                case 13:
                    if (showMessage === true) message/* default.success */.ZP.success("\u8349\u7A3F\u4FDD\u5B58\u6210\u529F!");
                    return _ctx.abrupt("return", res);
                case 17:
                    _ctx.next = 19;
                    return fixStatus(blogInfo.id, blogInfo.status);
                case 19:
                    _ctx.next = 21;
                    return _id_.update(blogInfo.id, body);
                case 21:
                    _ctx.next = 23;
                    return reload(slug1);
                case 23:
                    // await router.push(`/blog/${blogInfo.slug}`);
                    // await callback?.(blogInfo.slug);
                    if (showMessage === true) message/* default.success */.ZP.success("\u8349\u7A3F\u4FDD\u5B58\u6210\u529F!");
                    return _ctx.abrupt("return", blogInfo);
                case 25:
                    _ctx.next = 32;
                    break;
                case 27:
                    _ctx.prev = 27;
                    _ctx.t0 = _ctx["catch"](1);
                    ;
                    message/* default.error */.ZP.error("\u4FDD\u5B58\u5931\u8D25\uFF1A" + String((ref9 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) !== null && ref9 !== void 0 ? ref9 : _ctx.t0));
                    throw _ctx.t0;
                case 32:
                    _ctx.prev = 32;
                    setOperating(false);
                    return _ctx.finish(32);
                case 35:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                27,
                32,
                35
            ]
        ]);
    })), [
        slug1,
        router,
        editContext
    ]);
    var saveAndSubmit = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, slug, id, ref11;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return save(false);
                case 3:
                    ref = _ctx.sent;
                    slug = ref.slug;
                    id = ref.id;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return _id_.submit(id);
                case 9:
                    _ctx.prev = 9;
                    _ctx.next = 12;
                    return router.push("/blog/".concat(slug));
                case 12:
                    return _ctx.finish(9);
                case 13:
                    _ctx.next = 20;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    message/* default.error */.ZP.error("\u63D0\u4EA4\u5931\u8D25\uFF1A" + String((ref11 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) !== null && ref11 !== void 0 ? ref11 : _ctx.t0));
                    throw _ctx.t0;
                case 20:
                    _ctx.prev = 20;
                    setOperating(false);
                    return _ctx.finish(20);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                15,
                20,
                23
            ],
            [
                6,
                ,
                9,
                13
            ]
        ]);
    })), [
        save,
        reload
    ]);
    var saveAndPublish = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, slug, id, ref12;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return save(undefined);
                case 3:
                    ref = _ctx.sent;
                    slug = ref.slug;
                    id = ref.id;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return _id_.publish(id);
                case 9:
                    _ctx.prev = 9;
                    _ctx.next = 12;
                    return router.push("/blog/".concat(slug));
                case 12:
                    return _ctx.finish(9);
                case 13:
                    _ctx.next = 20;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                    message/* default.error */.ZP.error("\u53D1\u5E03\u5931\u8D25\uFF1A" + String((ref12 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) !== null && ref12 !== void 0 ? ref12 : _ctx.t0));
                    throw _ctx.t0;
                case 20:
                    _ctx.prev = 20;
                    setOperating(false);
                    return _ctx.finish(20);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                15,
                20,
                23
            ],
            [
                6,
                ,
                9,
                13
            ]
        ]);
    })), [
        save,
        reload
    ]);
    return {
        save: save,
        saveAndSubmit: saveAndSubmit,
        saveAndPublish: saveAndPublish,
        operating: operating
    };
}
function fixStatus(id, status) {
    return _fixStatus.apply(this, arguments);
}
function _fixStatus() {
    _fixStatus = _asyncToGenerator(runtime_default().mark(function _callee(id, status) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = status;
                    _ctx.next = _ctx.t0 === "PENDING" ? 3 : _ctx.t0 === "PUBLISHED" ? 6 : 18;
                    break;
                case 3:
                    _ctx.next = 5;
                    return _id_.cancelSubmit(id);
                case 5:
                    return _ctx.abrupt("break", 19);
                case 6:
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return new Promise(function(resolve, reject) {
                        modal/* default.confirm */.Z.confirm({
                            title: "\u786E\u8BA4\u64CD\u4F5C",
                            content: "\u5185\u5BB9\u66F4\u65B0\u540E\u9700\u8981\u91CD\u65B0\u5BA1\u6838\u624D\u80FD\u4E0A\u7EBF",
                            onOk: function() {
                                return resolve();
                            },
                            onCancel: function() {
                                return reject("canceled");
                            }
                        });
                    });
                case 9:
                    _ctx.next = 11;
                    return _id_.cancelPublish(id);
                case 11:
                    _ctx.next = 17;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t1 = _ctx["catch"](6);
                    if (!(_ctx.t1 !== "canceled")) {
                        _ctx.next = 17;
                        break;
                    }
                    throw _ctx.t1;
                case 17:
                    return _ctx.abrupt("break", 19);
                case 18:
                    return _ctx.abrupt("break", 19);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                13
            ]
        ]);
    }));
    return _fixStatus.apply(this, arguments);
}
/* harmony default export */ var edit_context = (EditContext);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleOutlined.js + 1 modules
var InfoCircleOutlined = __webpack_require__(45605);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/editing/editing.hooks.js
function editing_hooks_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function editing_hooks_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                editing_hooks_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                editing_hooks_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useTags = function() {
    var ref = (0,react.useState)([]), tags = ref[0], setTags = ref[1];
    (0,react.useEffect)(function() {
        var fetchAll = function() {
            var _ref = editing_hooks_asyncToGenerator(runtime_default().mark(function _callee() {
                var content;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return blog.getTags({
                                page: 1,
                                size: 100
                            });
                        case 2:
                            content = _ctx.sent.content;
                            setTags(content);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchAll() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchAll();
    }, []);
    return tags;
};
var useCategories = function() {
    var ref = (0,react.useState)([]), categories = ref[0], setCategories = ref[1];
    (0,react.useEffect)(function() {
        var fetchAll = function() {
            var _ref = editing_hooks_asyncToGenerator(runtime_default().mark(function _callee() {
                var content;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return blog.getCategories({
                                page: 1,
                                size: 100
                            });
                        case 2:
                            content = _ctx.sent.content;
                            setCategories(content);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchAll() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchAll();
    }, []);
    return categories;
};

// EXTERNAL MODULE: ./src/pages/blog/blog.hooks.js
var blog_hooks = __webpack_require__(99117);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/editing/ErrorBoundary.component.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ErrorBoundary, _Component);
    var _super = _createSuper(ErrorBoundary);
    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    _createClass(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                // You can also log the error to an error reporting service
                console.error("Error caught by Error Boundary:", error, info);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    // You can render any custom fallback UI
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            padding: 24,
                            textAlign: "center",
                            margin: "0 auto",
                            opacity: 0.7,
                            fontSize: 12,
                            fontWeight: "bold"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "\u7F16\u8F91\u6A21\u5F0F\u6682\u4E0D\u53EF\u7528"
                        })
                    });
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function getDerivedStateFromError(error) {
                // Update state so the next render will show the fallback UI.
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var ErrorBoundary_component = (ErrorBoundary);

;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/editing/Editing.component.js
function Editing_component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Editing_component_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Editing_component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Editing_component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







// import ImgCrop from 'antd-img-crop';








var spinIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
    style: {
        fontSize: 24
    },
    spin: true
});
var Editing = function(param) {
    var blogInfo = param.blogInfo;
    var ref3 = useEditContext(), factory = ref3.factory, // coverImageURL,
    // setCoverImageURL,
    // uploadCoverImage,
    title1 = ref3.title, setTitle = ref3.setTitle, origin = ref3.origin, setOrigin = ref3.setOrigin, category1 = ref3.category, setCategory = ref3.setCategory, tags1 = ref3.tags, setTags = ref3.setTags, content1 = ref3.content, setContent = ref3.setContent;
    var validationPublish = function(callback) {
        if (title1 === "") {
            message/* default.warn */.ZP.warn("\u8BF7\u8F93\u5165\u6807\u9898");
            return;
        }
        if (content1.length === 1 && content1[0].children.length === 1 && content1[0].children[0].text === "") {
            message/* default.warn */.ZP.warn("\u6B63\u6587\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A");
            return;
        }
        if (category1 === undefined || category1 === null) {
            message/* default.warn */.ZP.warn("\u8BF7\u9009\u62E9\u5206\u7C7B");
            return;
        }
        if (origin === undefined) {
            message/* default.warn */.ZP.warn("\u8BF7\u9009\u62E9\u662F\u5426\u539F\u521B");
            return;
        }
        if (origin === "") {
            message/* default.warn */.ZP.warn("\u5FC5\u987B\u586B\u5199\u8F6C\u8F7D\u6765\u6E90");
            return;
        }
        return callback();
    };
    var validationSaveDraft = function(callback) {
        if (title1 === "") {
            message/* default.warn */.ZP.warn("\u8BF7\u8F93\u5165\u6807\u9898");
            return;
        }
        if (content1.length === 1 && content1[0].children.length === 1 && content1[0].children[0].text === "") {
            message/* default.warn */.ZP.warn("\u6B63\u6587\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A");
            return;
        }
        if (origin === undefined) {
            message/* default.warn */.ZP.warn("\u8BF7\u9009\u62E9\u662F\u5426\u539F\u521B");
            return;
        }
        if (origin === "") {
            message/* default.warn */.ZP.warn("\u5FC5\u987B\u586B\u5199\u8F6C\u8F7D\u6765\u6E90");
            return;
        }
        return callback();
    };
    var ref1 = useEditMethods(), save = ref1.save, saveAndSubmit = ref1.saveAndSubmit, saveAndPublish = ref1.saveAndPublish, operating = ref1.operating;
    var hasAuthority = (0,blog_hooks/* usePrincipal */.j)().hasAuthority;
    var hasPermission = hasAuthority("PUBLISH_POST");
    var onTitleChange = function(e) {
        setTitle(e.currentTarget.value);
    };
    var onChangeOrigin = function(e) {
        setOrigin(e.currentTarget.value);
    };
    // const onClickRemoveCoverImage = (e) => {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   setCoverImageURL(undefined);
    // };
    var allCategories = useCategories();
    var allTags = useTags();
    var mappedCategoriesCollection = (0,react.useMemo)(function() {
        return allCategories.map(fromServerMeta);
    }, [
        allCategories
    ]);
    var mappedCategory = (0,react.useMemo)(function() {
        return fromServerMeta(category1);
    }, [
        category1
    ]);
    var mappedTagsCollection = (0,react.useMemo)(function() {
        return allTags.map(fromServerMeta);
    }, [
        allTags
    ]);
    var mappedTags = (0,react.useMemo)(function() {
        return tags1.map(fromServerMeta);
    }, [
        tags1
    ]);
    var uploadFile = (0,react.useCallback)(function() {
        var _ref = Editing_component_asyncToGenerator(runtime_default().mark(function _callee(file) {
            var ref, uploadURL, downloadURL;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return common.upload(file.name, file.type);
                    case 2:
                        ref = _ctx.sent;
                        uploadURL = ref.uploadURL;
                        downloadURL = ref.downloadURL;
                        _ctx.next = 7;
                        return axios_default().put(uploadURL, file, {
                            headers: {
                                "content-type": file.type,
                                "x-oss-object-acl": "public-read"
                            }
                        });
                    case 7:
                        return _ctx.abrupt("return", downloadURL);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var ref2 = (0,react.useState)(false), hanging = ref2[0], setHanging = ref2[1];
    var onAlert = (0,react.useCallback)(function(title, content) {
        notification/* default.warn */.Z.warn({
            message: title,
            description: content
        });
    }, []);
    var isCdnHost = (0,react.useCallback)(function(url) {
        return /tidb-blog/.test(url);
    }, []);
    var setHang = (0,react.useCallback)(function(val) {
        setHanging(val);
    }, []);
    if (false) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    (blogInfo === null || blogInfo === void 0 ? void 0 : blogInfo.status) === "PUBLISHED" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PublishedAlert, {}) : undefined,
                    (blogInfo === null || blogInfo === void 0 ? void 0 : blogInfo.status) === "PENDING" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingAlert, {}) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleInput, {
                        placeholder: "\u6587\u7AE0\u6807\u9898......",
                        value: title1,
                        onChange: onTitleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySelect, {
                                placeholder: "\u8BF7\u9009\u62E9\u5206\u7C7B",
                                options: mappedCategoriesCollection,
                                value: mappedCategory,
                                onChange: function(category) {
                                    return setCategory(toServerMeta(category));
                                },
                                labelInValue: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsSelect, {
                                placeholder: "\u6700\u591A\u9009\u62E9 5 \u4E2A\u6807\u7B7E \uD83C\uDFF7\uFE0F",
                                options: mappedTagsCollection,
                                value: mappedTags,
                                onChange: function(tags) {
                                    return setTags(tags.slice(0, 5).map(toServerMeta));
                                },
                                labelInValue: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                        spinning: hanging,
                        indicator: spinIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary_component, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_full_es/* default */.ZP, {
                                    value: content1,
                                    onChange: setContent,
                                    factory: factory,
                                    placeholder: "\u8BF7\u5728\u6B64\u5904\u5F00\u59CB\u64B0\u5199\u6B63\u6587\u2026\u2026",
                                    uploadFile: uploadFile,
                                    onAlert: onAlert,
                                    isCdnHost: isCdnHost,
                                    setHang: setHang
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                        checked: origin === false,
                        onChange: function() {
                            return setOrigin(false);
                        },
                        children: "\u539F\u521B"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                        checked: typeof origin === "string",
                        onChange: function() {
                            return setOrigin("");
                        },
                        children: "\u8F6C\u8F7D"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Definition, {
                children: origin === undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : origin !== false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                    value: origin === false ? "" : origin,
                    disabled: origin === false,
                    onChange: onChangeOrigin,
                    placeholder: "\u8BF7\u586B\u5199\u539F\u6587\u94FE\u63A5"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoCircleOutlined/* default */.Z, {}),
                        " \u7533\u8BF7\u539F\u521B\u5C06\u542F\u7528",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                            href: "https://creativecommons.org/licenses/by-nc-sa/4.0/",
                            children: "CC BY-NC-SA 4.0"
                        }),
                        " ",
                        "\u7248\u6743\u534F\u8BAE\uFF0C\u5982\u679C\u4E0D\u662F\u539F\u521B\u6587\u7AE0\uFF0C\u8BF7\u9009\u62E9\u8F6C\u8F7D\u3002"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btns",
                    children: [
                        hasPermission ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "primary",
                            onClick: function() {
                                return validationPublish(saveAndPublish);
                            },
                            loading: operating,
                            children: "\u53D1\u5E03"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "primary",
                            onClick: function() {
                                return validationPublish(saveAndSubmit);
                            },
                            loading: operating,
                            children: "\u63D0\u4EA4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "default",
                            onClick: function() {
                                return validationSaveDraft(function() {
                                    return save(true);
                                });
                            },
                            loading: operating,
                            children: "\u4FDD\u5B58\u8349\u7A3F"
                        })
                    ]
                })
            })
        ]
    });
};
var PublishedAlert = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_alert/* default */.Z, {
        type: "warning",
        message: "\u60A8\u6B63\u5728\u7F16\u8F91\u4E00\u4E2A\u5DF2\u53D1\u5E03\u7684\u6587\u7AE0\uFF0C\u4FEE\u6539\u6216\u91CD\u65B0\u63D0\u4EA4\u4F1A\u5C06\u8BE5\u6587\u7AE0\u4E0B\u7EBF\u3002"
    });
};
var PendingAlert = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_alert/* default */.Z, {
        type: "warning",
        message: "\u60A8\u6B63\u5728\u7F16\u8F91\u4E00\u4E2A\u5BA1\u6838\u4E2D\u7684\u6587\u7AE0\uFF0C\u4FEE\u6539\u5219\u9700\u8981\u91CD\u65B0\u63D0\u4EA4\u5BA1\u6838\u3002"
    });
};
var fromServerMeta = function(obj) {
    if (!obj) {
        return obj;
    }
    var id = obj.id, name = obj.name;
    return {
        label: name,
        value: id,
        key: id
    };
};
var toServerMeta = function(obj) {
    if (!obj) {
        return obj;
    }
    var label = obj.label, value = obj.value;
    return {
        id: value,
        name: label
    };
};
/* harmony default export */ var Editing_component = (Editing);

// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/previewing/previewing.styled.js
function previewing_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function previewing_styled_templateObject() {
    var data = previewing_styled_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    previewing_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Declaration = styled_components_browser_esm/* default.p */.ZP.p(previewing_styled_templateObject(), (0,polished_esm/* transparentize */.DZ)(0.5, colors.F2));

// EXTERNAL MODULE: ./src/pages/blog/_components/BlogInfo/index.js + 2 modules
var BlogInfo = __webpack_require__(3368);
// EXTERNAL MODULE: ./src/pages/blog/[slug]/components/labels.js + 1 modules
var labels = __webpack_require__(77153);
;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/previewing/Previewing.component.js











var noop = function() {};
var Previewing = function(param) {
    var blogInfo = param.blogInfo;
    var ref = useEditContext(), category = ref.category, factory = ref.factory, title = ref.title, origin = ref.origin, tags = ref.tags, content = ref.content, coverImageURL = ref.coverImageURL;
    var ref1 = useEditMethods(), save = ref1.save, saveAndSubmit = ref1.saveAndSubmit, saveAndPublish = ref1.saveAndPublish, operating = ref1.operating;
    var hasAuthority = (0,blog_hooks/* usePrincipal */.j)().hasAuthority;
    var hasPermission = hasAuthority("PUBLISH_POST");
    var validationPublish = function(callback) {
        if (title === "") {
            message/* default.warn */.ZP.warn("\u8BF7\u8F93\u5165\u6807\u9898");
            return;
        }
        if (category === undefined || category === null) {
            message/* default.warn */.ZP.warn("\u8BF7\u9009\u62E9\u5206\u7C7B");
            return;
        }
        return callback();
    };
    var validationSaveDraft = function(callback) {
        if (title === "") {
            message/* default.warn */.ZP.warn("\u8BF7\u8F93\u5165\u6807\u9898");
            return;
        }
        return callback();
    };
    if (false) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    coverImageURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverImage, {
                        style: {
                            backgroundImage: "url(".concat(JSON.stringify(coverImageURL), ")")
                        }
                    }) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleInput, {
                        readOnly: true,
                        value: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta, {
                        children: [
                            typeof origin === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(labels/* RepostLabel */.a, {
                                children: "\u8F6C\u8F7D"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(labels/* OriginLabel */.T, {
                                children: "\u539F\u521B"
                            }),
                            tags.map(function(tag) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogInfo/* default.Tag */.Z.Tag, {
                                    children: tag.name
                                }, tag.id);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_full_es/* default */.ZP, {
                            value: content,
                            onChange: noop,
                            factory: factory,
                            disabled: true
                        })
                    }),
                    typeof origin === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Declaration, {
                        children: [
                            "\u58F0\u660E\uFF1A\u672C\u6587\u8F6C\u8F7D\u4E8E ",
                            origin
                        ]
                    }) : undefined
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Actions, {
                children: [
                    (blogInfo === null || blogInfo === void 0 ? void 0 : blogInfo.status) === "PUBLISHED" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PublishedAlert, {}) : undefined,
                    (blogInfo === null || blogInfo === void 0 ? void 0 : blogInfo.status) === "PENDING" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PendingAlert, {}) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "btns",
                        children: [
                            hasPermission ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                onClick: function() {
                                    return validationPublish(saveAndPublish);
                                },
                                disabled: operating,
                                children: "\u53D1\u5E03"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                onClick: function() {
                                    return validationPublish(saveAndSubmit);
                                },
                                disabled: operating,
                                children: "\u63D0\u4EA4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "default",
                                onClick: function() {
                                    return validationSaveDraft(save);
                                },
                                disabled: operating,
                                children: "\u4FDD\u5B58\u8349\u7A3F"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Previewing_component = (Previewing);

;// CONCATENATED MODULE: ./src/pages/blog/[slug]/edit/index.page.js













var BlogEditPage = function() {
    var editContextValue = useEditContextProvider();
    var router = (0,next_router.useRouter)();
    var reload = editContextValue.reload, blogInfo = editContextValue.blogInfo;
    var login = (0,react.useContext)(context/* AuthContext */.Vo).login;
    var p = (0,blog_hooks/* usePrincipal */.j)();
    var isLogin = p.isLogin, loading = p.loading;
    (0,react.useEffect)(function() {
        if (!loading && !isLogin) {
            login();
        }
    }, [
        isLogin,
        login,
        loading
    ]);
    var slug = router.query.slug;
    (0,react.useEffect)(function() {
        if (router.isReady) {
            reload(slug);
        }
    }, [
        slug,
        reload,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
        MainWrapper: MainWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u535A\u5BA2 - \u7F16\u8F91\u6587\u7AE0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(edit_context.Provider, {
                    value: editContextValue,
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* default.TabPane */.Z.TabPane, {
                                tab: "\u7F16\u8F91",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editing_component, {
                                    blogInfo: blogInfo
                                })
                            }, "editing"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* default.TabPane */.Z.TabPane, {
                                tab: "\u9884\u89C8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Previewing_component, {
                                    blogInfo: blogInfo
                                })
                            }, "previewing")
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var index_page = (BlogEditPage);


/***/ }),

/***/ 50132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1413);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60136);
/* harmony import */ var _babel_runtime_helpers_esm_createSuper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29388);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);








// eslint-disable-next-line import/no-extraneous-dependencies



var Checkbox = /*#__PURE__*/function (_Component) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Checkbox, _Component);

  var _super = (0,_babel_runtime_helpers_esm_createSuper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Checkbox);

  function Checkbox(props) {
    var _this;

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, Checkbox);

    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;

      if (disabled) {
        return;
      }

      if (!('checked' in _this.props)) {
        _this.setState({
          checked: e.target.checked
        });
      }

      if (onChange) {
        onChange({
          target: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _this.props), {}, {
            checked: e.target.checked
          }),
          stopPropagation: function stopPropagation() {
            e.stopPropagation();
          },
          preventDefault: function preventDefault() {
            e.preventDefault();
          },
          nativeEvent: e.nativeEvent
        });
      }
    };

    _this.saveInput = function (node) {
      _this.input = node;
    };

    var checked = 'checked' in props ? props.checked : props.defaultChecked;
    _this.state = {
      checked: checked
    };
    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Checkbox, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          style = _this$props2.style,
          name = _this$props2.name,
          id = _this$props2.id,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          tabIndex = _this$props2.tabIndex,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          onKeyDown = _this$props2.onKeyDown,
          onKeyPress = _this$props2.onKeyPress,
          onKeyUp = _this$props2.onKeyUp,
          autoFocus = _this$props2.autoFocus,
          value = _this$props2.value,
          required = _this$props2.required,
          others = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this$props2, ["prefixCls", "className", "style", "name", "id", "type", "disabled", "readOnly", "tabIndex", "onClick", "onFocus", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "autoFocus", "value", "required"]);

      var globalProps = Object.keys(others).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
          // eslint-disable-next-line no-param-reassign
          prev[key] = others[key];
        }

        return prev;
      }, {});
      var checked = this.state.checked;
      var classString = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, className, (_classNames = {}, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-checked"), checked), (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: classString,
        style: style
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        name: name,
        id: id,
        type: type,
        required: required,
        readOnly: readOnly,
        disabled: disabled,
        tabIndex: tabIndex,
        className: "".concat(prefixCls, "-input"),
        checked: !!checked,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onChange: this.handleChange,
        autoFocus: autoFocus,
        ref: this.saveInput,
        value: value
      }, globalProps)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: "".concat(prefixCls, "-inner")
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('checked' in props) {
        return (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {}, {
          checked: props.checked
        });
      }

      return null;
    }
  }]);

  return Checkbox;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {}
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7878,228,7781,4642,9569,9774,2888,179], function() { return __webpack_exec__(28705); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);